import { logToServer } from '../API/logging.js';
import GenericErrorMessage from './GenericErrorMessage.js';
import { ErrorBoundary } from 'react-error-boundary';
import { AppContext } from './AppContext';
import { useContext, useEffect } from 'react';

export default function ReactErrorBoundary(props) {
	const [appState, setAppState] = useContext(AppContext);
	useEffect(() => {
		//clone the fetch function in order to handle 401 errors
		const { fetch: originalFetch } = window;
		if (!appState.fetchOverriden) {
			window.fetch = async (...args) => {
				let [resource, config] = args;
				let response = await originalFetch(resource, config);
				if (response && response.status === 401) {
					setAppState((prev) => ({
						...prev,
						user: '',
						fetchOverriden: false,
					}));

					window.location.href = `${process.env.REACT_APP_API_RETURN_URL}`;
					return;
				}
				return response;
			};
			setAppState((prev) => ({
				...prev,
				fetchOverriden: true,
			}));
		}
	}, [appState.fetchOverriden, setAppState]);

	return (
		<ErrorBoundary
			FallbackComponent={GenericErrorMessage}
			onError={(error, errorInfo) => {
				// log the error
				console.error(error);
				console.error(errorInfo);
				//try to log to server
				try {
					logToServer('Error', JSON.stringify({ error, errorInfo }));
				} catch (e) {
					console.error('Error logging to server: ', e);
				}
			}}
			onReset={() => {
				sessionStorage.clear();
				window.location.href = `${process.env.REACT_APP_API_RETURN_URL}`;
			}}
		>
			{props.children}
		</ErrorBoundary>
	);
}
